import type { HelpFile } from '../../types/help'
import { RestConfigEditDialogTestIds } from '../../../testids/RestConfigEditDialogTestIds'

export const restConfigEditDialogHelp: HelpFile = {
  docPage: '/docs/connectors/inbound',
  texts: {
    [RestConfigEditDialogTestIds.btnSaveRestConfig]:
      'REST-Verbindungseinstellungen speichern.',
    [RestConfigEditDialogTestIds.btnSaveScimConfig]:
      'SCIM-Konfiguration speichern.',
    [RestConfigEditDialogTestIds.btnCancelRestConfig]:
      'Ausstehende Änderungen an den REST-Verbindungseinstellungen verwerfen.',
    [RestConfigEditDialogTestIds.btnCancelScimConfig]:
      'Ausstehende SCIM-Konfigurationsänderungen verwerfen.',
    [RestConfigEditDialogTestIds.inputItemsJsonPath]:
      'JSON-Pfad oder XML-Elementpfad zum Items-Array. Bei CSV und TEXT deaktiviert.',
    [RestConfigEditDialogTestIds.selectResponseFormat]:
      'Antwortformat wählen, das das Quellsystem zurückgibt. Wechsel zu CSV oder TEXT löscht den Items-Pfad.',
    [RestConfigEditDialogTestIds.selectPaginationStyle]:
      'Pagination-Stil wählen — Cursor, Offset oder Seitenbasiert.',
    [RestConfigEditDialogTestIds.responseFormatJson]: null,
    [RestConfigEditDialogTestIds.responseFormatXml]: null,
    [RestConfigEditDialogTestIds.responseFormatCsv]: null,
    [RestConfigEditDialogTestIds.responseFormatText]: null,
    [RestConfigEditDialogTestIds.authTypeChangeWarning]:
      'Warnung beim Wechsel des Authentifizierungstyps — der Wechsel kann Secret-Referenzen zurücksetzen.',
    [RestConfigEditDialogTestIds.authTypeOptionAwsSigv4]: null,
    [RestConfigEditDialogTestIds.authTypeOptionMutualTls]: null,
    [RestConfigEditDialogTestIds.authTypeOptionNtlmKerberos]: null,
    [RestConfigEditDialogTestIds.authTypeOptionSignedRequest]: null,
    [RestConfigEditDialogTestIds.authTypeOptionGoogleSaJwt]: null,
    [RestConfigEditDialogTestIds.googleSaSectionHelp]: null,
    [RestConfigEditDialogTestIds.inputGoogleDelegatedUser]:
      'Das Google-Workspace-Administratorkonto, dessen Identität diese Integration übernimmt. Verwenden Sie ein dediziertes nicht-personales Admin-Konto (z. B. iam-sync@ihre-domain.com) — ein persönliches Konto funktioniert nicht mehr, sobald die Person ausscheidet.',
    [RestConfigEditDialogTestIds.inputGoogleSaEmail]:
      'Die E-Mail-Adresse des Dienstkontos (zu finden in der Google Cloud Console unter IAM → Dienstkonten).',
    [RestConfigEditDialogTestIds.inputGoogleSaKeySecretRef]:
      'Secret-Referenz auf den privaten RSA-Schlüssel des Dienstkontos (PKCS#8-PEM). Im Formular wird nur der Referenzname angezeigt — der aufgelöste Schlüssel erscheint nie.',
    [RestConfigEditDialogTestIds.inputGoogleTokenScope]:
      'Leerzeichen-getrennte OAuth-Scopes. Für eine lesende Benutzer-Synchronisation: https://www.googleapis.com/auth/admin.directory.user.readonly',
    [RestConfigEditDialogTestIds.inputAwsAccessKeySecretRef]:
      'Referenz auf das Secret mit dem AWS Access Key zum Signieren von Anfragen.',
    [RestConfigEditDialogTestIds.inputAwsRegion]:
      'AWS-Region für die SigV4-Signierung (zum Beispiel us-east-1).',
    [RestConfigEditDialogTestIds.inputAwsSecretKeySecretRef]:
      'Referenz auf das Secret mit dem AWS Secret Key zum Signieren von Anfragen.',
    [RestConfigEditDialogTestIds.inputAwsService]:
      'AWS-Servicename für die SigV4-Signierung (zum Beispiel execute-api).',
    [RestConfigEditDialogTestIds.inputClientCertSecretRef]:
      'Referenz auf das Client-Zertifikat-Secret für Mutual TLS.',
    [RestConfigEditDialogTestIds.inputClientKeySecretRef]:
      'Referenz auf das Secret mit dem privaten Client-Schlüssel für Mutual TLS.',
    [RestConfigEditDialogTestIds.inputKerberosKeytabSecretRef]:
      'Referenz auf das Kerberos-Keytab-Secret für die Authentifizierung.',
    [RestConfigEditDialogTestIds.inputKerberosPrincipal]:
      'Kerberos-Principal-Name (user@REALM).',
    [RestConfigEditDialogTestIds.inputKerberosRealm]:
      'Kerberos-Realm, der dem Principal zugeordnet ist.',
    [RestConfigEditDialogTestIds.inputSigningHeaderTemplate]:
      'HTTP-Header-Vorlage für signierte Anfragen; unterstützt Platzhalter für die Signatur.',
    [RestConfigEditDialogTestIds.inputSigningKeySecretRef]:
      'Referenz auf das Signaturschlüssel-Secret zur Berechnung von Anfragensignaturen.',
    [RestConfigEditDialogTestIds.inputTruststoreSecretRef]:
      'Referenz auf den Truststore mit der Server-Zertifizierungsstelle für Mutual TLS.',
    [RestConfigEditDialogTestIds.kerberosSectionHelp]: null,
    [RestConfigEditDialogTestIds.mtlsSectionHelp]: null,
    [RestConfigEditDialogTestIds.signedRequestSectionHelp]: null,
    [RestConfigEditDialogTestIds.sigv4SectionHelp]: null,
    [RestConfigEditDialogTestIds.restApiKeySecretRef]:
      'Referenz auf das API-Key-Secret, das mit jeder Anfrage gesendet wird.',
    [RestConfigEditDialogTestIds.restClientSecretRef]:
      'Referenz auf das OAuth2-Client-Secret.',
    [RestConfigEditDialogTestIds.restPasswordSecretRef]:
      'Referenz auf das Passwort-Secret für Basic-Authentifizierung.',
    [RestConfigEditDialogTestIds.restTokenSecretRef]:
      'Referenz auf das Bearer-Token-Secret.',
    [RestConfigEditDialogTestIds.selectSigningAlgorithm]:
      'Algorithmus zur Berechnung der Anfragensignatur.',
  },
}
